var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isVisible
    ? _c(
        "div",
        {
          staticClass: "modal-overlay",
          on: {
            click: function($event) {
              if ($event.target !== $event.currentTarget) {
                return null
              }
              return _vm.close.apply(null, arguments)
            }
          }
        },
        [
          _c("div", { staticClass: "dialog-body" }, [
            _c("div", { staticClass: "head-body", on: { click: _vm.close } }, [
              _vm._v("\n      关闭\n    ")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content-body" },
              _vm._l(_vm.uploadTaskList, function(item, index) {
                return _c("div", { key: index, staticClass: "item-body" }, [
                  _c("div", { staticClass: "item-img" }, [
                    _c("img", {
                      attrs: { src: _vm.$fileIcon(item.title), alt: "" }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "item-content" }, [
                    _c("div", { staticClass: "title" }, [
                      _vm._v(
                        "\n            " + _vm._s(item.title) + "\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "time" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$formatDate(item.time)) +
                          "\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "progress-container" }, [
                      _c("div", { staticClass: "progress-bar" }, [
                        _c("div", {
                          staticClass: "progress",
                          style: { width: item.progress + "%" }
                        })
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "status",
                      on: {
                        click: function($event) {
                          return _vm.clickItemStatus(item)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.statusMap[item.status]) +
                          "\n        "
                      )
                    ]
                  )
                ])
              }),
              0
            )
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35dfe96c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35dfe96c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/upload_progress_dialog.vue
// module id = null
// module chunks = 